import { useStore } from '../lib/store';

export function Toasts() {
  const { toasts, dismissToast } = useStore();

  return (
    <div class="toast-container" aria-live="polite" aria-atomic="true">
      {toasts.map((t) => (
        <div
          key={t.id}
          class={'toast ' + t.type}
          role={t.type === 'error' ? 'alert' : 'status'}
          onClick={() => dismissToast(t.id)}
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}
